export default "__VITE_ASSET__sdRFyYSR__"